import React, { Fragment } from "react"
import { Helmet } from "react-helmet"
import addToMailchimp from 'gatsby-plugin-mailchimp'
import swal from '@sweetalert/with-react'

export default class FullWidthMailList extends React.Component {
state = {
    email: null,
}

_handleChange = (e) => {
    this.setState({
        [`${e.target.name}`]: e.target.value,
    });
}

_handleSubmit = (e) => {
    e.preventDefault();

    console.log('submit', this.state);
    
    addToMailchimp(this.state.email, this.state)
        .then(({ msg, result }) => {
            console.log('msg', `${result}: ${msg}`);

            if (result !== 'success') {
                throw msg;
            }
            swal(msg);
        })
        .catch((err) => {
            console.log('err', err)
            if (err.includes("already")) {
                swal({
                    text: "Already subscribed!",
                    content: (<p>{this.state.email} is already subscribed to our mailing list. Thanks!</p>),
                    icon: "info",
                });
            } else if (err.includes("timeout")) {
                swal({
                    text: "Error!",
                    content: "Mailchimp timed out - a content blocker or tracking protection may be blocking the response.",
                    icon: "error",
                })
            } else {
                swal(err);
            }
        });
}

    render() {
    return (
        <Fragment>
        <Helmet>
            <script src="https://kit.fontawesome.com/3736921366.js" crossorigin="anonymous"></script>
        </Helmet>
        <div className="container-fluid color-one">
            <div className="row align-items-center p-4">
                <div className="col-md"></div>
                <div className="col">
                    <p className="med-text-color-bg m-0">Join our mailing list:</p>
                </div>
                <div className="col">
                    <form id="mail-form" onSubmit={this._handleSubmit}>
                        <div className="form-group m-0 mail-field">
                            <label for="email" id="email-help" className="sr-only">Email</label>
                            <input type="email" onChange={this._handleChange} placeholder="email" id="email" name="email" className="form-control-lg transparent-input border-0" aria-describedby="email-help"></input>
                            <button type="submit" className="pl-0"><i className="btn fas fa-arrow-alt-circle-right"></i><p className="sr-only">Submit</p> </button>
                        </div>
                    </form>
                </div>
                <div className="col-md"></div>
            </div>
        </div>
        </Fragment>
    )
    }
}